import React from "react";
import { StoreProvider } from "./store-context";

export const createWrapRootElement = (store) => {
  const WrapRootElement = ({ element }) => (
    <StoreProvider store={store}>{element}</StoreProvider>
  );

  return WrapRootElement;
};
